import { ProjectId } from 'api/models';
import { ProjectUsersLiteQueryKey } from 'api/project';

export type ProjectTasksQueryKey = [string, number];
export type ProjectSprintsQueryKey = [string, number];
export type SprintsDropdown = [string, number];

export const getProjectTasksQueryKey = ([
  ,
  projectId,
]: ProjectId): ProjectTasksQueryKey => ['tasks', projectId];
export const getProjectDetailQueryKey = (projectId: ProjectId): ProjectId => {
  return projectId;
};

export const getProjectSprintsQueryKey = ([
  ,
  projectId,
]: ProjectId): ProjectSprintsQueryKey => ['sprints', projectId];

export const getSprintsForProject = ([
  ,
  projectId,
]: ProjectId): SprintsDropdown => ['sprints-drpdown', projectId[1]];

export const getProjectUsersLiteKey = (
  projectId?: number,
): ProjectUsersLiteQueryKey => [
  'project-users-lite',
  `${projectId?.toString() ?? 'all'}`,
];

export const getProjectDependencyMapKey = (projectId) => [
  'project-dependency-map',
  `${projectId.toString()}`,
];
